export type ContentCategory = 'news' | 'entertainment' | 'lifestyle';

export interface ContentItem {
  id: string;
  title: string;
  summary: string;
  category: ContentCategory;
  categoryName: string;
  tag: string;
  author: string;
  date: string;
  image: string;
  views: number;
  featured: boolean;
  body: string[];
}

export const categoryMeta: Record<ContentCategory, { name: string; path: string; desc: string; icon: string }> = {
  news: {
    name: '资讯',
    path: '/news',
    desc: '最新新闻与热点资讯，涵盖社会、科技、财经',
    icon: 'ri-newspaper-line',
  },
  entertainment: {
    name: '娱乐',
    path: '/entertainment',
    desc: '影视资讯与娱乐动态，覆盖电影、电视剧与明星',
    icon: 'ri-movie-2-line',
  },
  lifestyle: {
    name: '生活',
    path: '/lifestyle',
    desc: '健康、美食、旅游、购物，一站式生活服务',
    icon: 'ri-store-2-line',
  },
};

export const contentList: ContentItem[] = [
  // ---------------- 资讯 / NEWS ----------------
  {
    id: 'n-transit',
    title: '城市轨道交通新线今日正式开通运营',
    summary: '新线全长三十余公里，连接主城与新城，早高峰通勤时间预计缩短约二十分钟。',
    category: 'news',
    categoryName: '资讯',
    tag: '社会',
    author: '小 · 城市观察',
    date: '2026-10-14',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20modern%20city%20metro%20line%20map%20with%20clean%20geometric%20shapes%20navy%20and%20orange%20accents%20minimal%20flat%20design&width=1000&height=640&seq=content-n-transit&orientation=landscape',
    views: 18640,
    featured: true,
    body: [
      '今日清晨六时，城市轨道交通新线首班列车准点驶出站台，标志着这条历时四年建设的东西向交通大动脉正式投入运营。沿线共设车站二十一座，串联起主城核心区、科技园区与南部新城。',
      '据运营方介绍，新线采用全自动驾驶技术，高峰时段最小行车间隔缩短至三分钟。初步测算，沿线居民早高峰通勤时间平均可节省约二十分钟。',
      '多位市民在采访中表示，新线开通后跨区通勤更加从容。运营方还同步上线了智能出行小程序，可实时查询拥挤度并规划换乘方案。',
    ],
  },
  {
    id: 'n-ai-model',
    title: '国产开源大模型发布，多项能力登上榜首',
    summary: '新模型在中文理解、代码生成与多模态任务上表现突出，权重全面开源。',
    category: 'news',
    categoryName: '资讯',
    tag: '科技',
    author: '小 · 科技前线',
    date: '2026-10-13',
    image: 'https://readdy.ai/api/search-image?query=abstract%20technology%20visualization%20of%20a%20neural%20network%20made%20of%20glowing%20nodes%20deep%20navy%20background%20with%20warm%20orange%20highlights%20minimal%20elegant&width=1000&height=640&seq=content-n-ai-model&orientation=landscape',
    views: 24310,
    featured: true,
    body: [
      '昨日，一支国内研究团队正式发布新一代开源大模型，并同步开放模型权重与推理代码。评测数据显示，该模型在中文理解、代码生成、多模态问答等多项公开榜单上位居前列。',
      '团队负责人表示，本次发布重点优化了推理效率，在同等硬件条件下吞吐量提升明显，便于中小开发者部署。',
      '业内分析认为，开源路线的持续投入将加速人工智能应用在各行各业的落地，也会推动相关工具链与生态进一步完善。',
    ],
  },
  {
    id: 'n-rate',
    title: '央行宣布下调存款准备金率，释放长期资金',
    summary: '此次调整将释放中长期流动性，支持实体经济融资需求。',
    category: 'news',
    categoryName: '资讯',
    tag: '财经',
    author: '小 · 财经频道',
    date: '2026-10-12',
    image: 'https://readdy.ai/api/search-image?query=clean%20financial%20concept%20illustration%20with%20rising%20bar%20charts%20and%20coins%20on%20a%20warm%20beige%20background%20navy%20and%20orange%20tones%20flat%20minimal&width=1000&height=640&seq=content-n-rate&orientation=landscape',
    views: 15980,
    featured: false,
    body: [
      '央行于今日宣布下调金融机构存款准备金率，此次调整将向市场释放可观的中长期流动性，进一步降低实体经济融资成本。',
      '分析人士指出，此次操作释放了稳增长的政策信号，有助于改善市场预期，为四季度经济运行提供支撑。',
      '多家机构预计，后续货币政策将继续保持稳健取向，在稳增长与防风险之间寻求平衡。',
    ],
  },
  {
    id: 'n-ev',
    title: '新能源汽车下乡政策扩围，覆盖更多县域市场',
    summary: '新一轮政策在补贴、充电设施与金融支持方面进一步加码。',
    category: 'news',
    categoryName: '资讯',
    tag: '财经',
    author: '小 · 汽车观察',
    date: '2026-10-11',
    image: 'https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20of%20an%20electric%20car%20charging%20station%20in%20a%20small%20town%20warm%20palette%20navy%20and%20orange%20clean%20lines&width=1000&height=640&seq=content-n-ev&orientation=landscape',
    views: 11230,
    featured: false,
    body: [
      '相关部门近日联合发布通知，新能源汽车下乡活动范围进一步扩大，覆盖更多县域与乡镇市场，并在购车补贴、充电设施建设、金融信贷等方面给出配套支持。',
      '多位经销商反馈，乡村与县域市场对经济型电动车型需求旺盛，充电便利性正成为购车决策的关键因素。',
      '专家表示，随着基础设施下沉与产品矩阵丰富，县域市场有望成为新能源汽车增长的重要引擎。',
    ],
  },
  {
    id: 'n-heat',
    title: '多地发布高温橙色预警，注意防暑降温',
    summary: '气象部门提醒午后减少户外活动，及时补充水分。',
    category: 'news',
    categoryName: '资讯',
    tag: '社会',
    author: '小 · 民生播报',
    date: '2026-10-10',
    image: 'https://readdy.ai/api/search-image?query=abstract%20warm%20sun%20and%20heat%20waves%20illustration%20with%20soft%20gradient%20orange%20peach%20tones%20minimal%20flat%20design&width=1000&height=640&seq=content-n-heat&orientation=landscape',
    views: 9840,
    featured: false,
    body: [
      '受持续晴热天气影响，多地气象台今日发布高温橙色预警，预计未来三天部分区域最高气温可达三十七摄氏度以上。',
      '气象部门建议公众尽量避免在午后高温时段进行户外劳作，老幼体弱人群需注意补水与防暑，户外作业单位应合理安排作息。',
      '医疗专家同时提醒，高温天气下中暑与心脑血管疾病风险上升，出现头晕、乏力等症状应及时就医。',
    ],
  },
  {
    id: 'n-chip',
    title: '国产芯片制造工艺取得阶段性突破',
    summary: '新工艺在良率与功耗控制上明显改进，有望缓解高端产能压力。',
    category: 'news',
    categoryName: '资讯',
    tag: '科技',
    author: '小 · 科技前线',
    date: '2026-10-09',
    image: 'https://readdy.ai/api/search-image?query=macro%20style%20abstract%20illustration%20of%20a%20silicon%20chip%20with%20circuit%20lines%20navy%20blue%20and%20orange%20accents%20dark%20background%20minimal%20elegant&width=1000&height=640&seq=content-n-chip&orientation=landscape',
    views: 20150,
    featured: false,
    body: [
      '国内某半导体企业宣布，其新一代制造工艺在流片验证中取得阶段性成果，芯片良率与功耗控制较上一代明显改善。',
      '企业技术负责人表示，团队在关键设备与材料环节持续推进国产化替代，为后续量产打下基础。',
      '研究机构认为，制造工艺的稳步推进对完善本土产业链具有重要意义，但仍需在设备与人才方面持续投入。',
    ],
  },
  {
    id: 'n-ecommerce',
    title: '跨境电商出口持续增长，中小卖家加速出海',
    summary: '海外仓与本地化运营成为新一轮增长的关键抓手。',
    category: 'news',
    categoryName: '资讯',
    tag: '财经',
    author: '小 · 财经频道',
    date: '2026-10-08',
    image: 'https://readdy.ai/api/search-image?query=clean%20flat%20illustration%20of%20global%20shipping%20boxes%20and%20a%20world%20map%20with%20route%20lines%20warm%20beige%20background%20navy%20orange%20palette&width=1000&height=640&seq=content-n-ecommerce&orientation=landscape',
    views: 8760,
    featured: false,
    body: [
      '最新数据显示，本季度跨境电商出口保持较快增长，中小卖家通过多平台布局与本地化运营，成为出海新势力。',
      '业内人士表示，海外仓布局与售后本地化显著提升了用户体验与复购率，正成为品牌化出海的标配。',
      '专家提醒，卖家需关注海外合规、物流时效与汇率波动等风险因素，稳健经营。',
    ],
  },
  {
    id: 'n-eldercare',
    title: '社区养老服务全面升级，助餐点覆盖更多小区',
    summary: '多地推进嵌入式养老，让老年人在家门口享受多元服务。',
    category: 'news',
    categoryName: '资讯',
    tag: '社会',
    author: '小 · 民生播报',
    date: '2026-10-07',
    image: 'https://readdy.ai/api/search-image?query=warm%20minimal%20illustration%20of%20a%20community%20center%20with%20elderly%20care%20services%20soft%20beige%20and%20orange%20tones%20flat%20design&width=1000&height=640&seq=content-n-eldercare&orientation=landscape',
    views: 7420,
    featured: false,
    body: [
      '为进一步完善社区养老服务体系，多地近期新增一批社区嵌入式养老服务点，提供助餐、助浴、日间照料与健康监测等服务。',
      '已有社区引入智能设备，可对独居老人的活动与健康数据进行日常关注，异常情况会及时通知家属与社区工作人员。',
      '工作人员表示，嵌入式服务让老年人留在熟悉的环境中，兼顾了照护需求与情感归属。',
    ],
  },
  {
    id: 'n-medical-ai',
    title: 'AI 医疗影像辅助诊断系统获批上市',
    summary: '系统可辅助医生快速识别常见影像病变，提升基层筛查效率。',
    category: 'news',
    categoryName: '资讯',
    tag: '科技',
    author: '小 · 科技前线',
    date: '2026-10-06',
    image: 'https://readdy.ai/api/search-image?query=clean%20medical%20imaging%20concept%20illustration%20with%20scan%20panels%20and%20AI%20grid%20overlay%20white%20and%20soft%20blue%20with%20orange%20accent%20minimal&width=1000&height=640&seq=content-n-medical-ai&orientation=landscape',
    views: 13380,
    featured: false,
    body: [
      '一款人工智能医疗影像辅助诊断系统近日通过审批并正式上市，可在胸部影像筛查中辅助医生快速识别常见病变，标注可疑区域。',
      '研发团队介绍，系统在大量临床数据上完成训练与验证，能够帮助基层医疗机构提升筛查效率，缓解影像医生不足的压力。',
      '专家强调，人工智能在此类场景中承担辅助角色，最终诊断仍由专业医生结合临床信息作出判断。',
    ],
  },
  {
    id: 'n-renovation',
    title: '老旧小区改造提速，加装电梯与停车设施成重点',
    summary: '新一轮改造更注重居民实际需求与后续长效管理。',
    category: 'news',
    categoryName: '资讯',
    tag: '社会',
    author: '小 · 城市观察',
    date: '2026-10-05',
    image: 'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20renewed%20residential%20community%20with%20greenery%20and%20modern%20facilities%20warm%20beige%20navy%20orange%20palette%20minimal&width=1000&height=640&seq=content-n-renovation&orientation=landscape',
    views: 6980,
    featured: false,
    body: [
      '今年新一轮老旧小区改造加快推进，加装电梯、增设停车位、完善无障碍设施与适老化改造成为改造重点。',
      '不少小区在改造前充分征询居民意见，按照轻重缓急制定方案，避免大拆大建，力求实用与美观兼顾。',
      '相关负责人表示，改造完成后还将引入物业与自治机制，确保设施长期可用、维护到位。',
    ],
  },
  {
    id: 'n-digital-report',
    title: '数字经济运行报告发布，产业数字化步伐加快',
    summary: '报告显示数字经济核心产业增加值保持较快增长。',
    category: 'news',
    categoryName: '资讯',
    tag: '财经',
    author: '小 · 财经频道',
    date: '2026-10-04',
    image: 'https://readdy.ai/api/search-image?query=abstract%20data%20and%20analytics%20dashboard%20illustration%20with%20charts%20and%20grid%20lines%20warm%20neutral%20background%20navy%20and%20orange%20tones%20minimal&width=1000&height=640&seq=content-n-digital-report&orientation=landscape',
    views: 8120,
    featured: false,
    body: [
      '最新发布的数字经济运行报告显示，数字经济核心产业增加值保持较快增长，产业数字化转型步伐明显加快。',
      '报告指出，制造业、零售业与服务业在智能化改造上的投入持续增加，数据要素价值加快释放。',
      '专家建议，在推动数字化的同时要重视数据安全与人才培养，让数字经济红利惠及更多行业与群体。',
    ],
  },
  {
    id: 'n-tourism',
    title: '假期文旅消费数据出炉，短途游与夜间经济亮眼',
    summary: '周边游、文化体验游与夜间消费成为假期新亮点。',
    category: 'news',
    categoryName: '资讯',
    tag: '社会',
    author: '小 · 民生播报',
    date: '2026-10-03',
    image: 'https://readdy.ai/api/search-image?query=stylized%20illustration%20of%20a%20lively%20night%20market%20with%20lanterns%20and%20visitors%20warm%20orange%20glow%20navy%20sky%20minimal%20flat%20design&width=1000&height=640&seq=content-n-tourism&orientation=landscape',
    views: 10450,
    featured: false,
    body: [
      '假日期间，各地文旅市场持续升温。数据显示，短途周边游、文化体验类项目与夜间消费成为本次假期的突出亮点。',
      '不少城市通过打造特色街区、延时开放博物馆与推出惠民活动，进一步激发居民与游客的消费热情。',
      '业内人士表示，文旅消费正从走马观花转向深度体验，对服务品质与内容创意提出了更高要求。',
    ],
  },

  // ---------------- 娱乐 / ENTERTAINMENT ----------------
  {
    id: 'e-scifi',
    title: '暑期档科幻大片定档，预告片燃爆全网',
    summary: '影片以近未来为背景，视效与世界观设定引发广泛讨论。',
    category: 'entertainment',
    categoryName: '娱乐',
    tag: '电影',
    author: '小 · 娱乐前线',
    date: '2026-10-14',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20poster%20style%20art%20of%20a%20futuristic%20city%20and%20spaceship%20silhouette%20deep%20navy%20sky%20with%20orange%20horizon%20glow%20dramatic%20minimal&width=900&height=1200&seq=content-e-scifi&orientation=portrait',
    views: 34210,
    featured: true,
    body: [
      '备受期待的暑期档科幻大片今日正式定档，首支预告片上线后迅速登上多个平台热搜榜，播放量在数小时内突破千万。',
      '影片以近未来为背景，讲述一群普通人在危机中携手寻找出路的故事。制作团队在视效与世界观的构建上投入了大量精力。',
      '导演在采访中表示，希望影片在宏大场面之外，更能传递关于勇气与信任的情感内核。',
    ],
  },
  {
    id: 'e-suspense',
    title: '悬疑剧集口碑逆袭，低调开播后强势出圈',
    summary: '扎实的剧本与克制的表演让这部剧在后期口碑走高。',
    category: 'entertainment',
    categoryName: '娱乐',
    tag: '电视剧',
    author: '小 · 剧集观察',
    date: '2026-10-13',
    image: 'https://readdy.ai/api/search-image?query=moody%20cinematic%20poster%20art%20of%20a%20dim%20city%20alley%20with%20a%20lone%20figure%20and%20a%20single%20street%20lamp%20navy%20and%20amber%20tones%20minimal%20suspense&width=900&height=1200&seq=content-e-suspense&orientation=portrait',
    views: 28760,
    featured: false,
    body: [
      '一部没有大张旗鼓宣传的悬疑剧集近日凭借扎实的剧本实现口碑逆袭，追更人数持续攀升，相关话题频频登上讨论榜。',
      '观众普遍认为，剧集在叙事节奏与细节铺垫上颇为用心，演员克制的表演也让角色更加可信。',
      '有评论指出，这类作品的成功说明，观众对题材扎实、尊重智力的内容始终有稳定的需求。',
    ],
  },
  {
    id: 'e-shanhai',
    title: '电影《山海》定档暑期，国风美学引发期待',
    summary: '取材传统神话，以东方美学重新讲述山海之间的少年旅程。',
    category: 'entertainment',
    categoryName: '娱乐',
    tag: '电影',
    author: '小 · 娱乐前线',
    date: '2026-10-12',
    image: 'https://readdy.ai/api/search-image?query=oriental%20ink%20painting%20style%20poster%20of%20rolling%20mountains%20and%20sea%20with%20a%20tiny%20figure%20elegant%20navy%20ink%20and%20warm%20orange%20sun%20minimal&width=900&height=1200&seq=content-e-shanhai&orientation=portrait',
    views: 21980,
    featured: true,
    body: [
      '取材于传统神话的动画电影《山海》今日宣布定档暑期，同步放出的国风海报与概念短片收获大量好评。',
      '影片以东方美学重新讲述山海之间的少年旅程，美术团队在色彩与意境上做了大量考据与再创作。',
      '制片方表示，希望观众在欣赏视觉奇观的同时，也能感受到故事里关于成长与守护的朴素情感。',
    ],
  },
  {
    id: 'e-actor-award',
    title: '青年演员斩获国际电影节最佳新人奖',
    summary: '凭借在文艺片中的细腻表演获得评委认可。',
    category: 'entertainment',
    categoryName: '娱乐',
    tag: '明星动态',
    author: '小 · 星闻速递',
    date: '2026-10-11',
    image: 'https://readdy.ai/api/search-image?query=elegant%20minimal%20poster%20art%20of%20a%20film%20award%20trophy%20and%20stage%20spotlight%20navy%20and%20gold%20tones%20refined%20cinematic&width=900&height=1200&seq=content-e-actor-award&orientation=portrait',
    views: 26340,
    featured: false,
    body: [
      '在近日落幕的一场国际电影节上，一位青年演员凭借文艺片中的出色表现摘得最佳新人奖，成为该单元备受关注的东方面孔。',
      '评委会评价其在片中的表演细腻而有层次，成功塑造了一个沉默却充满张力的角色。',
      '获奖后，这位演员在社交平台感谢导演与团队，并表示将继续打磨演技，尝试更多元的角色。',
    ],
  },
  {
    id: 'e-costume',
    title: '古装大剧正式杀青，制作特辑展现匠心细节',
    summary: '剧组公布的制作特辑展示了服装、道具与场景的考究。',
    category: 'entertainment',
    categoryName: '娱乐',
    tag: '电视剧',
    author: '小 · 剧集观察',
    date: '2026-10-10',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20poster%20art%20of%20an%20ancient%20chinese%20palace%20corridor%20with%20red%20lanterns%20elegant%20navy%20dusk%20and%20warm%20glow%20minimal%20refined&width=900&height=1200&seq=content-e-costume&orientation=portrait',
    views: 17650,
    featured: false,
    body: [
      '历经数月拍摄，古装大剧于近日正式杀青。剧组同步发布制作特辑，展示了服装、道具与场景搭建的考究细节。',
      '美术指导介绍，团队参考了大量历史资料，在尊重传统的基础上进行艺术化处理，力求真实与美感兼顾。',
      '该剧预计将于明年与观众见面，具体播出安排尚未公布。',
    ],
  },
  {
    id: 'e-musicfest',
    title: '秋季音乐节阵容公布，多支乐队确认登台',
    summary: '音乐节将设置主舞台与电子舞台，覆盖多元音乐风格。',
    category: 'entertainment',
    categoryName: '娱乐',
    tag: '明星动态',
    author: '小 · 星闻速递',
    date: '2026-10-09',
    image: 'https://readdy.ai/api/search-image?query=energetic%20concert%20poster%20art%20with%20crowd%20silhouettes%20and%20stage%20lights%20deep%20navy%20sky%20orange%20beam%20minimal%20graphic&width=900&height=1200&seq=content-e-musicfest&orientation=portrait',
    views: 19420,
    featured: false,
    body: [
      '秋季音乐节今日公布完整阵容，多支人气乐队与独立音乐人确认登台，涵盖摇滚、民谣与电子等多种风格。',
      '主办方介绍，本次音乐节将设置主舞台与电子舞台，并增设互动体验与市集区域，打造沉浸式的音乐周末。',
      '门票将于本周开售，主办方提醒观众通过官方渠道购票，谨防非正规渠道风险。',
    ],
  },
  {
    id: 'e-director',
    title: '导演新作入围国际电影节主竞赛单元',
    summary: '影片以家庭视角切入时代变迁，收获海外媒体好评。',
    category: 'entertainment',
    categoryName: '娱乐',
    tag: '电影',
    author: '小 · 娱乐前线',
    date: '2026-10-08',
    image: 'https://readdy.ai/api/search-image?query=minimal%20artistic%20poster%20of%20an%20empty%20cinema%20seat%20and%20projection%20beam%20navy%20darkness%20with%20warm%20light%20refined%20cinematic&width=900&height=1200&seq=content-e-director&orientation=portrait',
    views: 12480,
    featured: false,
    body: [
      '一部国产影片近日确认入围某国际电影节主竞赛单元。影片以家庭视角切入时代变迁，情感克制而真挚。',
      '多位海外影评人给予积极评价，认为影片在叙事与影像语言上都有独到之处。',
      '导演表示，能站上这样的舞台与世界观众交流，是对团队多年坚持的一种肯定。',
    ],
  },
  {
    id: 'e-variety',
    title: '热门综艺第二季回归，赛制升级看点十足',
    summary: '新一季在赛制与嘉宾阵容上双双升级，首期播出反响热烈。',
    category: 'entertainment',
    categoryName: '娱乐',
    tag: '明星动态',
    author: '小 · 星闻速递',
    date: '2026-10-07',
    image: 'https://readdy.ai/api/search-image?query=colorful%20playful%20poster%20art%20of%20a%20tv%20studio%20stage%20with%20geometric%20shapes%20navy%20base%20and%20orange%20accents%20minimal%20graphic&width=900&height=1200&seq=content-e-variety&orientation=portrait',
    views: 15890,
    featured: false,
    body: [
      '备受关注的热门综艺第二季于上周回归，新一季在赛制设计与嘉宾阵容上双双升级，首期播出后反响热烈。',
      '节目组透露，本季更加注重真实互动与临场反应，减少了剧本痕迹，让嘉宾之间的化学反应成为最大看点。',
      '不少观众在社交平台分享观后感，认为节目在娱乐性之外也传递了积极向上的态度。',
    ],
  },
  {
    id: 'e-animation',
    title: '动画电影票房破纪录，成人向题材再受关注',
    summary: '影片凭借成熟的主题表达与精良制作赢得广泛好评。',
    category: 'entertainment',
    categoryName: '娱乐',
    tag: '电影',
    author: '小 · 娱乐前线',
    date: '2026-10-06',
    image: 'https://readdy.ai/api/search-image?query=artistic%20animated%20film%20poster%20of%20a%20boy%20on%20a%20hill%20under%20a%20vast%20starry%20sky%20navy%20blue%20with%20warm%20orange%20stars%20minimal%20painterly&width=900&height=1200&seq=content-e-animation&orientation=portrait',
    views: 22870,
    featured: false,
    body: [
      '一部动画电影近日刷新同类题材的票房纪录。影片凭借成熟的主题表达与精良的制作水准，赢得了不同年龄层观众的好评。',
      '影评人认为，影片证明了动画不只是儿童专属，同样可以承载深刻的情感与思考。',
      '制作团队表示，创作过程中最难的是在商业性与作者表达之间找到平衡，观众的认可给了他们很大鼓励。',
    ],
  },

  // ---------------- 生活 / LIFESTYLE ----------------
  {
    id: 'l-weekend',
    title: '周边城市周末微度假，三条路线轻松出发',
    summary: '不用长途奔波，一个周末就能收获松弛感。',
    category: 'lifestyle',
    categoryName: '生活',
    tag: '旅游',
    author: '小 · 生活家',
    date: '2026-10-14',
    image: 'https://readdy.ai/api/search-image?query=soft%20illustration%20of%20a%20weekend%20road%20trip%20through%20green%20hills%20with%20a%20small%20car%20warm%20sunlight%20beige%20and%20sage%20palette%20minimal%20flat&width=1000&height=640&seq=content-l-weekend&orientation=landscape',
    views: 16720,
    featured: true,
    body: [
      '不想长途奔波，又想换个心情？其实在周边城市，一个周末就足够完成一次高质量的微度假。',
      '我们整理了三条各有侧重的路线：一条主打山野徒步，一条聚焦古镇美食，还有一条适合亲子出行。',
      '出发前建议提前查看天气与路况，把行程安排得松弛一些，留出随意走走的时间，反而更容易收获惊喜。',
    ],
  },
  {
    id: 'l-health',
    title: '秋冬养生饮食指南，吃对了更舒服',
    summary: '顺应时节调整饮食结构，温润好消化是关键。',
    category: 'lifestyle',
    categoryName: '生活',
    tag: '健康',
    author: '小 · 健康说',
    date: '2026-10-13',
    image: 'https://readdy.ai/api/search-image?query=clean%20flat%20illustration%20of%20seasonal%20autumn%20foods%20like%20pumpkin%20and%20chestnuts%20on%20a%20warm%20beige%20background%20earthy%20palette%20minimal&width=1000&height=640&seq=content-l-health&orientation=landscape',
    views: 13460,
    featured: false,
    body: [
      '天气转凉，饮食也应跟着时节做一点调整。秋冬养生并不神秘，核心是温润、好消化、营养均衡。',
      '可以适当增加山药、南瓜、银耳、莲藕等温润食材，同时保证优质蛋白与新鲜蔬果的摄入，避免一味进补。',
      '此外，规律作息、适度运动与充足饮水同样重要。饮食调整应循序渐进，特殊体质人群建议咨询专业医师。',
    ],
  },
  {
    id: 'l-recipe',
    title: '家常菜十分钟上桌，新手也能零失败',
    summary: '三步搞定一道下饭菜，忙碌日子的救星。',
    category: 'lifestyle',
    categoryName: '生活',
    tag: '美食',
    author: '小 · 厨房日记',
    date: '2026-10-12',
    image: 'https://readdy.ai/api/search-image?query=overhead%20flat%20lay%20of%20a%20simple%20home%20cooked%20dish%20in%20a%20ceramic%20bowl%20on%20a%20wooden%20table%20warm%20beige%20natural%20light%20minimal&width=1000&height=640&seq=content-l-recipe&orientation=landscape',
    views: 19230,
    featured: false,
    body: [
      '忙碌的工作日，最需要的就是一道十分钟能上桌、又足够下饭的家常菜。',
      '以番茄炒蛋为例：鸡蛋打散加少许盐，番茄切块备用；热锅下油先炒蛋盛出，再下番茄炒出汁水；最后合炒调味即可。',
      '掌握几个小技巧就能明显提升口感：蛋液里加一点水更嫩，番茄去皮更顺滑，出锅前撒一点葱花提香。',
    ],
  },
  {
    id: 'l-closet',
    title: '换季衣物收纳技巧，省空间还不伤衣服',
    summary: '分类清洗、防潮防虫，来年取出来依旧如新。',
    category: 'lifestyle',
    categoryName: '生活',
    tag: '购物',
    author: '小 · 生活家',
    date: '2026-10-11',
    image: 'https://readdy.ai/api/search-image?query=tidy%20minimal%20illustration%20of%20folded%20clothes%20and%20storage%20boxes%20in%20a%20closet%20warm%20neutral%20beige%20palette%20flat%20design&width=1000&height=640&seq=content-l-closet&orientation=landscape',
    views: 9820,
    featured: false,
    body: [
      '换季收纳做得好，来年再拿出来时衣服依旧平整如新，还能省下不少柜子空间。',
      '收纳前务必把衣物清洗干净并彻底晾干，避免残留的汗渍与湿气导致发黄、发霉。针织类尽量折叠平放，避免悬挂变形。',
      '存放时可以使用带密封的收纳箱，并放置防潮与防虫用品，标注好类别与季节，取用时会方便很多。',
    ],
  },
  {
    id: 'l-fitness',
    title: '居家健身计划，每天二十分钟动起来',
    summary: '无需器械，一块瑜伽垫就能完成全身训练。',
    category: 'lifestyle',
    categoryName: '生活',
    tag: '健康',
    author: '小 · 健康说',
    date: '2026-10-10',
    image: 'https://readdy.ai/api/search-image?query=minimal%20illustration%20of%20a%20yoga%20mat%20and%20water%20bottle%20in%20a%20bright%20living%20room%20warm%20beige%20palette%20flat%20design&width=1000&height=640&seq=content-l-fitness&orientation=landscape',
    views: 11240,
    featured: false,
    body: [
      '没时间跑健身房？其实在家花二十分钟，一块瑜伽垫就能完成一次不错的全身训练。',
      '建议按热身、力量、拉伸的顺序进行：先做五分钟动态热身，再完成深蹲、俯卧撑、臀桥等基础动作，最后用拉伸收尾。',
      '关键在于坚持与循序渐进，动作质量比数量更重要，过程中注意呼吸节奏，如有不适及时停止。',
    ],
  },
  {
    id: 'l-coffee',
    title: '手冲咖啡入门，在家也能喝出好风味',
    summary: '从选豆到注水，几个要点帮你稳定出品。',
    category: 'lifestyle',
    categoryName: '生活',
    tag: '美食',
    author: '小 · 厨房日记',
    date: '2026-10-09',
    image: 'https://readdy.ai/api/search-image?query=clean%20photo%20style%20of%20a%20pour%20over%20coffee%20setup%20with%20dripper%20and%20kettle%20on%20a%20warm%20wooden%20counter%20minimal%20beige&width=1000&height=640&seq=content-l-coffee&orientation=landscape',
    views: 8650,
    featured: false,
    body: [
      '手冲咖啡看起来讲究，其实掌握几个要点就能稳定出品，在家也能喝到干净明亮的风味。',
      '首先是豆子与研磨：选择新鲜烘焙的豆子，研磨度以中细为宜。水温建议在九十度上下，先焖蒸再分段注水。',
      '粉水比可以从一比十五开始尝试，再根据口味微调。别怕失败，多试几次就能找到属于自己的那杯。',
    ],
  },
  {
    id: 'l-camping',
    title: '秋季露营装备清单，新手照着买不踩坑',
    summary: '从帐篷到照明，把钱花在真正需要的地方。',
    category: 'lifestyle',
    categoryName: '生活',
    tag: '旅游',
    author: '小 · 生活家',
    date: '2026-10-08',
    image: 'https://readdy.ai/api/search-image?query=cozy%20minimal%20illustration%20of%20a%20camping%20tent%20with%20string%20lights%20under%20a%20dusk%20sky%20warm%20orange%20and%20navy%20palette%20flat%20design&width=1000&height=640&seq=content-l-camping&orientation=landscape',
    views: 14380,
    featured: false,
    body: [
      '秋天的天气最适合露营，但第一次置办装备很容易买多或买错。',
      '必备清单大致包括：帐篷与防潮垫、睡袋、折叠桌椅、照明与充电设备、户外炉具与餐具，以及基础的急救用品。',
      '新手不必追求一步到位，可以先租借或选择轻量入门款，实际体验过几次再逐步升级，把钱花在真正影响体验的地方。',
    ],
  },
  {
    id: 'l-appliance',
    title: '家电以旧换新怎么参与？一篇看懂流程',
    summary: '旧机回收、补贴领取与选购要点一次说清。',
    category: 'lifestyle',
    categoryName: '生活',
    tag: '购物',
    author: '小 · 消费指南',
    date: '2026-10-07',
    image: 'https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20of%20home%20appliances%20like%20refrigerator%20and%20washing%20machine%20warm%20beige%20background%20navy%20orange%20accents&width=1000&height=640&seq=content-l-appliance&orientation=landscape',
    views: 10260,
    featured: false,
    body: [
      '新一轮家电以旧换新活动正在推进，不少家庭关心旧机怎么处理、补贴如何领取。',
      '一般流程是：确认参与活动的品类与门店、提交旧机信息并预约回收、在指定渠道购买新机时核销补贴。',
      '选购时建议优先关注能效等级与售后服务，而不只是价格。保留好购买与回收凭证，便于后续查询与维权。',
    ],
  },
  {
    id: 'l-sleep',
    title: '改善睡眠质量的五个小习惯，今晚就能试试',
    summary: '不用买贵价装备，调整习惯就能睡得更好。',
    category: 'lifestyle',
    categoryName: '生活',
    tag: '健康',
    author: '小 · 健康说',
    date: '2026-10-06',
    image: 'https://readdy.ai/api/search-image?query=calm%20minimal%20illustration%20of%20a%20cozy%20bedroom%20at%20night%20with%20soft%20lamp%20light%20navy%20and%20warm%20beige%20palette%20flat%20design&width=1000&height=640&seq=content-l-sleep&orientation=landscape',
    views: 12980,
    featured: false,
    body: [
      '睡不好并不一定要依赖装备或补剂，几个简单的生活习惯调整，往往就能带来明显改善。',
      '建议固定作息时间、睡前一小时远离屏幕、把卧室光线调暗并保持凉爽，同时避免睡前大量进食与摄入咖啡因。',
      '白天适度运动、多晒太阳也有助于夜间入睡。如果长期失眠影响生活，应及时寻求专业帮助。',
    ],
  },
];